import React, { FC } from 'react'
import { Modal, Button } from '@wmgtech/legato'
import styles from './confirmation-modal.module.scss'
import { IConfirmationModalProps } from './confirmation-modal.props'

export const ConfirmationModal: FC<IConfirmationModalProps> = ({
  isOpen,
  setClose,
  confirmationText,
  onAction,
  header,
  actionText = 'Delete',
  cancelText = 'Cancel'
}) => {
  return (
    <Modal isOpen={isOpen} title={header} onClose={setClose} className={styles.modal}>
      <div className={styles.content}>{confirmationText}</div>
      <div className={styles.btns}>
        <Button onClick={setClose} containerStyle="outline" colorType="info">
          {cancelText}
        </Button>
        <Button onClick={onAction} colorType="info">
          {actionText}
        </Button>
      </div>
    </Modal>
  )
}
